module.exports = __webpack_public_path__ + "img/popup_option2.3c7ce0a.png";